import { render, staticRenderFns } from "./PageAsideCom.vue?vue&type=template&id=1f389167&scoped=true"
import script from "./PageAsideCom.vue?vue&type=script&lang=js"
export * from "./PageAsideCom.vue?vue&type=script&lang=js"
import style0 from "./PageAsideCom.vue?vue&type=style&index=0&id=1f389167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f389167",
  null
  
)

export default component.exports